<template>
	<v-dialog v-model="dialog" persistent max-width="800">
		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">{{ answerColumn.name }}</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="closeDialog" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="pa-2" v-if="uploadAreaFlag">
				<DragUpload
					ref="upload"
					:label="'アップロード'"
					:targetIndex="'1'"
					@fileShare="filesUpload"
				/>
			</div>
			<v-card-text class="pa-2" v-if="!uploadAreaFlag">
				<v-data-table
					:headers="headers"
					:items="attachedFiles"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="添付ファイルがありません"
				>
					<template v-slot:item="{ item }">
						<tr>
							<td @click="openFile(item)">
								<v-icon>{{ choiceIcon(item.icon_type) }}</v-icon>
								{{ item.name }}
							</td>
							<td>{{ item.created_at | dateFormatter }}</td>
							<td>{{ item.user_name }}</td>
							<td>
								<v-icon v-if="item && sameDepartmentFlag" @click="openDeleteModal(item)"
									>mdi-delete</v-icon
								>
							</td>
						</tr>
					</template>
				</v-data-table>
			</v-card-text>
			<div class="d-flex justify-center" v-if="isLoading">
				<v-progress-circular indeterminate color="primary"></v-progress-circular>
			</div>
			<v-divider></v-divider>
			<v-card-actions>
				<v-row no-gutters>
					<v-col cols="4"
						><v-btn color="grey darken-1" text @click="openDeleteHistory"> 削除履歴 </v-btn></v-col
					>
					<v-col cols="4" class="text-center">
						<v-btn
							v-if="sameDepartmentFlag && !uploadAreaFlag"
							color="grey darken-1"
							text
							@click="uploadAreaFlag = true"
							>追加</v-btn
						>
						<v-btn
							v-if="sameDepartmentFlag && uploadAreaFlag"
							color="grey darken-1"
							text
							@click="uploadAreaFlag = false"
							>戻る</v-btn
						>
					</v-col>
					<v-col cols="4">
						<v-row no-gutters justify="end">
							<v-btn color="grey darken-1" text @click="closeDialog"> 閉じる </v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
		<DeleteConfirm ref="deleteConfirm" @chose="deleteFile" />
		<ValueFileDeleteHistory ref="deleteFileHistory" :files="deletedFiles" />
	</v-dialog>
</template>
<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import rules from "../../../helper/rules"
import common from "../../../helper/common"
import DeleteConfirm from "./DeleteConfirm.vue"
import ValueFileDeleteHistory from "./ValueFileDeleteHistory.vue"
import DragUpload from "../../shared/DragUpload.vue"
import moment from "moment/min/moment.min.js"
export default {
	components: {
		DeleteConfirm,
		ValueFileDeleteHistory,
		DragUpload,
	},
	filters: {
		dateFormatter(date) {
			return moment(date).format("YYYY/MM/DD")
		},
		timeFormatter(time) {
			return moment(time).format("HH:mm")
		},
	},
	props: {},
	data() {
		return {
			common: common,
			dialog: false,
			rules: rules,
			valueId: "",
			answerColumn: { name: "" },
			attachedFiles: [],
			deleteTargetId: "",
			deletedFiles: [],
			sameDepartmentFlag: false,
			uploadAreaFlag: false,
			isLoading: false,
			headers: [
				{ text: "ファイル名", value: "file_name", width: "250px" },
				{ text: "追加日", value: "created_at", width: "100px" },
				{ text: "追加者", value: "user_name", width: "100px" },
				{ text: "削除", value: "delete_btn", width: "30px" },
			],
		}
	},
	methods: {
		filesUpload(files, index) {
			this.isLoading = true
			let promise1 = new Promise(() => {
				files.forEach((file) => {
					this.fileUpload(file)
				})
			})
			let promise2 = new Promise(() => {
				this.isLoading = false
				this.$refs.upload.resetFiles()
				this.uploadAreaFlag = false
				this.$store.commit("setFlash", {
					text: "アップロード完了",
					type: "notice",
				})
			})
			async function fire() {
				await promise1
				await promise2
			}
			fire()
		},
		fileUpload(file) {
			const headers = authenticate.setHeader()
			headers["content-type"] = "multipart/form-data"
			const formData = new FormData()
			formData.append("value", JSON.stringify({ id: this.valueId }))
			formData.append("file", file)
			axios
				.post("/erp/v1/answer_values/files", formData, { headers })
				.then((res) => {
					this.getAttachedFiles()
					this.$emit("reloadAnswer")
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openDeleteHistory() {
			this.$refs.deleteFileHistory.openDialog()
		},
		openDeleteModal(attachedFile) {
			this.deleteTargetId = attachedFile.id
			let title = attachedFile.name
			let message = "本当に削除しますか？\nファイルが削除され、削除履歴が残ります。"
			this.$refs.deleteConfirm.openDialog(title, message)
		},
		deleteFile() {
			const headers = authenticate.setHeader()
			axios
				.delete("/erp/v1/answer_values/files/" + this.deleteTargetId + ".json", {
					headers,
				})
				.then((response) => {
					this.getAttachedFiles()
					this.$store.commit("setFlash", {
						text: "削除しました",
						type: "notice",
					})
					this.$emit("reloadAnswer")
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
		openDialog(id) {
			this.valueId = id
			this.dialog = true
			this.getAttachedFiles()
		},
		closeDialog() {
			this.valueId = ""
			this.dialog = false
			this.attachedFiles = []
			this.answerColumn = { name: "" }
			this.attachedFiles = []
			this.deleteTargetId = ""
			this.deletedFiles = []
			this.sameDepartmentFlag = false
			this.uploadAreaFlag = false
			this.isLoading = false
		},
		choiceIcon(icon_type) {
			if (icon_type == "img") {
				return "mdi-image"
			} else if (icon_type == "pdf") {
				return "mdi-file-pdf-box"
			} else if (icon_type == "word") {
				return "mdi-file-word-outline"
			} else if (icon_type == "excel") {
				return "mdi-file-excel-outline"
			} else if (icon_type == "powerpoint") {
				return "mdi-file-powerpoint-outline"
			} else if (icon_type == "music") {
				return "mdi-music"
			} else if (icon_type == "movie") {
				return "mdi-filmstrip"
			} else if (icon_type == "cad") {
				return "mdi-file-cad"
			} else {
				return "mdi-file-outline"
			}
		},
		openFile(attachedFile) {
			window.open(attachedFile.url, "_blank")
		},
		getAttachedFiles() {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/answer_values/files/" + this.valueId + ".json", {
					headers,
				})
				.then((response) => {
					this.answerColumn = response.data.column
					this.attachedFiles = response.data.files
					this.deletedFiles = response.data.deleted_files
					this.sameDepartmentFlag = response.data.same_department_flag
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
	},
	watch: {},
}
</script>
<style scoped>
.overflow-x-scroll {
	overflow-x: scroll;
}
</style>
